import { useEffect } from "react";
import Theme from "@core/theme";

const root = document.documentElement;

const setProperty = (name: string, value: string | null) => {
  root.style.setProperty(name, value);
};

const useTheme = () => {
  useEffect(() => {
    setProperty("--ion-color-primary", Theme.primaryColor);
    setProperty("--ion-color-primary-rgb", Theme.primaryColorRgb);
    setProperty("--ion-color-primary-contrast", Theme.primaryColorContrast);
    setProperty("--ion-color-primary-contrast-rgb", Theme.primaryColorContrastRgb);
    setProperty("--ion-color-primary-shade", Theme.primaryColorShade);
    setProperty("--ion-color-primary-tint", Theme.primaryColorTint);
    setProperty("--ion-color-secondary", Theme.secondaryColor);
    setProperty("--ion-color-secondary-rgb", Theme.secondaryColorRgb);
    setProperty("--ion-color-secondary-contrast", Theme.secondaryColorContrast);
    setProperty("--ion-color-secondary-contrast-rgb", Theme.secondaryColorContrastRgb);
    setProperty("--ion-color-secondary-shade", Theme.secondaryColorShade);
    setProperty("--ion-color-secondary-tint", Theme.secondaryColorTint);
    setProperty("--ion-color-ternary", Theme.ternaryColor);
    setProperty("--ion-color-ternary-contrast", Theme.ternaryColorContrast);
    setProperty("--ion-toolbar-color", Theme.toolbarColor);
    setProperty("--toolbal-background-color-value", Theme.toolbarBackgroundColor);
    setProperty("--toolbal-background-color-contrast", Theme.toolbarBackgroundColorConstrast);
    setProperty("--home-page-category-size", Theme.homePageCategorySize);
    setProperty("--category-icon-padding", Theme.categoryIconPadding);
    setProperty("--category-card-br", Theme.categoryCardBR);
    setProperty("--category-card-image-br", Theme.categoryCardImageBR);
    setProperty("--cart-product-br", Theme.cartProductBR);
    setProperty("--cart-product-image-br", Theme.cartProductImageBR);
    setProperty("--category-icon-size", Theme.categoryIconSize);
    setProperty("--header-logo-width-minimized", Theme.headerLogoWidthMinimized);
    setProperty("--header-logo-height-minimized", Theme.headerLogoHeightMinimized);
    setProperty("--header-logo-width", Theme.headerLogoWidth);
    setProperty("--border-radius-value", Theme.borderRadiusValue);
    setProperty("--border-radius-product-value", Theme.borderRadiusProductValue);
    setProperty("--ion-color-sections-value", Theme.colorSectionsValue);

    setProperty("--ion-color-danger", Theme.dangerColor);
    setProperty("--ion-color-danger-shade", Theme.dangerColorShade);
    setProperty("--ion-color-danger-contrast", Theme.dangerColorContrast);
    setProperty("--ion-color-danger-contrast-rgb", Theme.dangerColorContrastRgb);
    setProperty("--ion-color-danger-tint", Theme.dangerColorTint);
    setProperty("--ion-color-danger-rgb", Theme.dangerColorRgb);

    setProperty("--ion-color-new-product", Theme.colorNewProduct);
    setProperty("--transform-scale-value-category", Theme.transformScaleValueCategory);
    setProperty("--transform-scale-value", Theme.transformScaleValue);
    setProperty("--border-radius-button-value", Theme.borderRadiusButtonValue);
    setProperty("--border-radius-input-value", Theme.borderRadiusInputValue);
    setProperty("--border-radius-toolbar-value", Theme.borderRadiusToolbarValue);
    setProperty("--border-radius-card-value", Theme.borderRadiusCardValue);
    setProperty("--border-shadow-new-list-product", Theme.borderShadowNewListProduct);
    setProperty("--ion-card-border-value", Theme.cardBorderValue);
    setProperty("--border-radius-new-list-value", Theme.borderRadiusNewListValue);
    setProperty("--border-product-new-list-bottom", Theme.borderProductNewListBottom);

    setProperty("--ion-color-light", Theme.lightColor);
    setProperty("--ion-color-light-rgb", Theme.lightColorRgb);
    setProperty("--ion-color-light-tint", Theme.lightColorTint);
    setProperty("--ion-color-light-shade", Theme.lightColorShade);
    setProperty("--ion-color-light-contrast", Theme.lightColorContrast);
    setProperty("--ion-color-light-contrast-rgb", Theme.lightColorContrastRgb);

    setProperty("--ion-color-medium", Theme.mediumColor);
    setProperty("--ion-color-medium-rgb", Theme.mediumColorRgb);
    setProperty("--ion-color-medium-tint", Theme.mediumColorTint);
    setProperty("--ion-color-medium-shade", Theme.mediumColorShade);
    setProperty("--ion-color-medium-contrast", Theme.mediumColorContrast);
    setProperty("--ion-color-medium-contrast-rgb", Theme.mediumColorContrastRgb);

    setProperty("--ion-color-success", Theme.successColor);
    setProperty("--ion-color-success-rgb", Theme.successColorRgb);
    setProperty("--ion-color-success-tint", Theme.successColorTint);
    setProperty("--ion-color-success-shade", Theme.successColorShade);
    setProperty("--ion-color-success-contrast", Theme.successColorContrast);
    setProperty("--ion-color-success-contrast-rgb", Theme.successColorContrastRgb);

    setProperty("--ion-color-warning", Theme.warningColor);
    setProperty("--ion-color-warning-rgb", Theme.warningColorRgb);
    setProperty("--ion-color-warning-tint", Theme.warningColorTint);
    setProperty("--ion-color-warning-shade", Theme.warningColorShade);
    setProperty("--ion-color-warning-contrast", Theme.warningColorContrast);
    setProperty("--ion-color-warning-contrast-rgb", Theme.warningColorContrastRgb);

    setProperty("--ion-color-dark", Theme.darkColor);
    setProperty("--ion-color-dark-rgb", Theme.darkColorRgb);
    setProperty("--ion-color-dark-tint", Theme.darkColorTint);
    setProperty("--ion-color-dark-shade", Theme.darkColorShade);
    setProperty("--ion-color-dark-contrast", Theme.darkColorContrast);
    setProperty("--ion-color-dark-contrast-rgb", Theme.darkColorContrastRgb);

    setProperty("--subtitle-category-color", Theme.searchMainCategoriesSubtitleColor);
    setProperty("--home-page-category-slide-padding", Theme.homePageCategorySlidePadding);
    setProperty("--home-page-category-slide-shadow", Theme.homePageCategorySlideShadow);

    setProperty("--image-background-color", Theme.imageBackgroundColor);
    setProperty("--slider-item-margin-right", Theme.sliderItemMarginRight);
    setProperty("--swiper-navigation-size", Theme.swiperNavigationSize);

    setProperty("--stories-border-read-color", Theme.storiesBorderReadColor);
    setProperty("--stories-gap", Theme.storiesGap);
    setProperty("--stories-height", Theme.storiesHeight);
    setProperty("--stories-list-side-padding", Theme.storiesListSidePadding);
    setProperty("--stories-list-bottom-margin", Theme.storiesListBottomMargin);
    setProperty("--stories-list-border-read-width", Theme.storiesListBorderReadWidth);
    setProperty("--stories-list-border-gap-read", Theme.storiesListBorderGapRead);
    setProperty("--stories-list-border-radius-read", Theme.storiesListBorderRadiusRead);
    setProperty("--stories-list-controls-size", Theme.storiesListControlsSize);
    setProperty("--stories-list-controls-background-color", Theme.storiesListControlsBackgroundColor);
    setProperty("--stories-list-controls-color", Theme.storiesListControlsColor);
    setProperty("--stories-list-inner-border-radius-not-read", Theme.storiesListInnerBorderRadiusNotRead);
    setProperty("--stories-list-inner-border-radius-read", Theme.storiesListInnerBorderRadiusRead);

    setProperty("--stories-list-item-title-padding", Theme.storiesListItemTitlePadding);
    setProperty("--stories-list-item-title-font", Theme.storiesListItemTitleFont);
    setProperty("--stories-list-item-title-font-family", Theme.storiesListItemTitleFontFamily);
    setProperty("--stories-list-item-title-color", Theme.storiesListItemTitleColor);
    setProperty("--stories-list-border-radius", Theme.storiesListBorderRadius);
    setProperty("--stories-list-border-gap-not-read", Theme.storiesListBorderGapNotRead);
    setProperty("--stories-list-border-not-read-width", Theme.storiesListBorderNotReadWidth);
    setProperty("--stories-border-not-read-color", Theme.storiesBorderNotReadColor);
    setProperty("---list-border-radiustoriess-image", Theme.storiesListBorderRadiusImage);

    setProperty("--product-slider-card-width", Theme.productSliderCardWidth);
    setProperty("--product-slider-card-min-width", Theme.productSliderCardMinWidth);
    setProperty("--product-slider-card-max-width", Theme.productSliderCardMaxWidth);

    setProperty("--collection-bg-color", Theme.collectionBGColor);
    setProperty("--collection-title-font-size", Theme.collectionTitleFontSize);
    setProperty("--collection-show-all-bg-color", Theme.collectionShowAllBGColor);
    setProperty("--collection-show-all-text-color", Theme.collectionShowAllTextColor);
    setProperty("--collections-size", Theme.collectionsSize);
    setProperty("--collection-size", Theme.collectionSize);
    setProperty("--collections-radius", Theme.collectionsRadius);
    setProperty("--height-bottom-tabs", Theme.heightBottomTabs);

    // root.style.setProperty("", Theme.);
  }, []);
};

export { useTheme };
